<template>
  <div nav-clear
       style="width: 100%; height:100%;position: fixed; left: 0px; right: 0px; top: 0px; bottom: 0px; background-color: #61AFC4;z-index: 100000000;display: inline-block;  text-align: center; border: solid 15px #fff;"
       class="congress-back-color" v-if="showPassword">
    <div style="margin-top:env(safe-area-inset-top) !important;">
      <img class="conference-image-progress mt-4" src="/assets/icon/icon.png"
           style="width: 150px;height:150px">
      <div translate="APP_LOGIN" style="text-align: left;font-size: 1.2rem">

      </div>
      <br>
      <div class="list">
        <!--label class="item item-input"> <span class="input-label">Username</span>
            <input type="text">
        </label-->



        <div class="item item-input-inset" style="border: none;">
          <label class="item-input-wrapper px-2">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" v-model="consent">
              <label class="form-check-label pt-1" for="flexCheckDefault" style="color:#fff">
                I hereby confirm that I have reviewed the <strong @click="linkClicked()"><u>{{fullname}} policies</u></strong> and will fully comply with them during the conference.
              </label>
            </div>
          </label>

        </div>
        <button class="btn mt-2 ms-2" @click="loginClicked()" v-if="consent" style="background: #fff; color:#203A65">
          Login
        </button>
        <div v-if="isError" class="item list-item list-item-title-1 item-text-wrap">
          {{error}}
        </div>
      </div>

    </div>
  </div>

</template>
<script>
import {defineComponent} from 'vue';
import {mapState, mapActions, mapGetters, mapMutations} from "vuex";
const config = require('@/config')
import {isPlatform} from "@ionic/vue";

export default defineComponent({
  name: 'ConsentDisclaimer',
  data() {
    return {
      consent: '',
      isError:false,
      error:'',
      fullname: config.full_name,
      privacyPolicyLink: config.privacy_policy_link,
    }
  },
  computed: {
    ...mapGetters('auth', ['user']),
    ...mapState('splashscreen', ['showPassword']),
    isLoggedIn() {
      return !!(this.user && this.user.id && localStorage.getItem('x-api-key'));
    },
  },
  methods: {
    ...mapActions('banners', ['getForState']),
    ...mapActions("settings", [
      "getSetting",
    ]),
    ...mapActions("files", [
      "getImage",
    ]),
    ...mapMutations("splashscreen", [
      "setShowPassword","setShowHelp"
    ]),

    ...mapActions('auth',['login']),

    getStyle(splash) {
      return {
        'background-image': 'url(' + splash || '' + ')',
        'background-repeat': 'no-repeat',
        'background-position': 'center center',
        'background-size': 'contain'
      }
    },
    async loginClicked () {
      await this.login()
      this.isError = false;
    },

    linkClicked(){
      let link = this.privacyPolicyLink;
      if ((isPlatform('ios') || isPlatform('android')) && typeof cordova != 'undefined') {
        let ref = cordova.InAppBrowser.open(link, '_blank', 'location=no,clearcache=no,clearsessioncache=no,toolbartranslucent=no,toolbarposition=top,toolbarcolor=#002a32,closebuttoncolor=#ffffff'); // eslint-disable-line
      } else {
        window.open(link, 'blank')
      }

    },


    initPassword() {
      if (!config.loginRequired) {
        this.setShowPassword(false);
        return;
      }

      this.setShowPassword(!this.isLoggedIn);
    }
  },
  created() {
    this.initPassword();
  },
  watch: {
    user() {
      this.initPassword();
    },
  }
});
</script>
<style lang="scss" scoped>
#password {
  position: absolute;
  background-color: white !important;
  z-index: 1040; //999;
  width: 100%;
  height: 100%;

}
</style>
